import { UserStatus } from "@socialcoach/services";
import { AssistantPermission, PricePlanTier, SubscriptionStatus } from "@/interfaces";

export type UserRole = "ADMIN" | "EDITOR" | "PLAYER" | "COACH" | "ASSISTANT_COACH";
export const ALL_USER_ROLES: UserRole[] = ["ADMIN", "EDITOR", "PLAYER", "COACH", "ASSISTANT_COACH"];

export interface SocialCoachSession {
  userId: number;
  userGuid: string;
  userRole: UserRole;
  status: UserStatus;
  coachId?: number;
  playerId?: number;

  email: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  phone?: string;
  photoUrl?: string;
  title?: string;
  complianceDisclaimer?: string;

  companyName: string;
  supportEmail: string;
  signUpStep?: number;
  subscription?: SocialCoachSubscription;
  userPermissions: AssistantPermission[];

  // Whether the signed-in account (the actor, while impersonating) can open other accounts.
  canImpersonate?: boolean;
  mfaVerified?: boolean;
  mfaPhone: MfaPhone;
  actor?: SocialCoachActorSession;
}

export interface MfaPhone {
  phoneNumber: string;
  verifiedAt: string;
  smsTosAcceptedAt: string;
}

export interface SocialCoachActorSession {
  email: string;
  fullName: string;
  photoUrl?: string;
}

export interface SocialCoachSubscription {
  status: SubscriptionStatus;
  tier: PricePlanTier;
  hasPaymentPlan: boolean;
}

export interface UpdateMeParams {
  firstName?: string;
  lastName?: string;
  photoUrl?: string;
  email?: string;
}
